import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { DeeplinkDto } from 'src/app/api/vehicle-deeplinks/models';
import { TestdriveService } from 'src/app/shared/testdrive/testdrive.service';

import { NbaParamResolver } from '../nba-param-resolver.interface';

import { NbaParamResolverId } from './nba-param-resolver-id.enum';

@Injectable()
export class TestdriveUrlResolver implements NbaParamResolver {
  public readonly identifier: string = NbaParamResolverId.TestdriveUrl;

  public constructor(private readonly testdriveService: TestdriveService) {}

  /**
   * @returns resolved testdrive url
   */
  public resolve$(): Observable<string> {
    return this.testdriveService.getDeeplinkInfo().pipe(
      map((result: DeeplinkDto) => result?.url),
      catchError((): Observable<string> => of('')) // no link in case of an error
    );
  }
}
